import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {RegModalComponent} from "./modals/reg-modal/reg-modal.component";
import {RegStep1Component} from "./modals/reg-modal/reg-step1/reg-step1.component";
import {RegStep2Component} from "./modals/reg-modal/reg-step2/reg-step2.component";
import {RegStep3Component} from "./modals/reg-modal/reg-step3/reg-step3.component";
import {RegStep4Component} from "./modals/reg-modal/reg-step4/reg-step4.component";
import {MinRegModalComponent} from "./modals/min-reg-modal/min-reg-modal.component";
import {LoginModalComponent} from "./modals/login-modal/login-modal.component";
import {LogoutModalComponent} from "./modals/logout-modal/logout-modal.component";
import {ReactiveFormsModule} from "@angular/forms";
import {TranslateModule} from "@ngx-translate/core";
import {SvgIconComponent} from "./svg-icon/svg-icon.component";
import {ResetPasswordModalComponent} from "./modals/reset-password-modal/reset-password-modal.component";
import {TermsComponent} from "./terms/terms.component";
import {RouterLink} from "@angular/router";



@NgModule({
  declarations: [
    RegModalComponent,
    RegStep1Component,
    RegStep2Component,
    RegStep3Component,
    RegStep4Component,
    MinRegModalComponent,
    LoginModalComponent,
    LogoutModalComponent,
    ResetPasswordModalComponent,
    SvgIconComponent,
    TermsComponent

  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslateModule,
    RouterLink
  ],
  exports: [
    RegModalComponent,
    RegStep1Component,
    RegStep2Component,
    RegStep3Component,
    RegStep4Component,
    MinRegModalComponent,
    LoginModalComponent,
    LogoutModalComponent,
    ResetPasswordModalComponent,
    SvgIconComponent,
    TermsComponent

  ]
})
export class SharedModule { }
